export const TLEmployerSettingsRoutes = {
    "/schedule-settings?activeTab": {
        "loginRequired": true,
        "name": "appLayout.schedule.settings",
        "enableBrandSwitchRedirect": true,
        "hideNotificationsModal": true,
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                "component": "tlEmployerSettingsPage"
            }
        },
        "onEnter": ['$state', '$stateParams', '$location', 'useNavFactory', 'useSettingsNav', async ($state, $stateParams, $location, useNavFactory, useSettingsNav) => {
            const navFactory = useNavFactory();
            return navFactory.init(useSettingsNav().settingsNav)
                .then(() => {
                    if (!$stateParams.activeTab && navFactory.state.activeNavs.length) {
                        const item = navFactory.state.activeNavs[0][0].filteredSections[0].items[0];
                        setTimeout(() => {
                            Utils.goToUrl(item.href());
                        }, 100);
                    } else if (!navFactory.state.activeNavs.length) {
                        $state.go('appLayout.harriSH.dashboard');
                    }
                })
                .catch((err) => {
                    console.error(err);
                });
        }],
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["pay_runs", 'abs-settings', "tl_compliance_settings", "settings_forms_wrapper", 'organization_settings', 'work-visas', 'job-titles-management', 'live-shift-alerts','notifications-management', 'shared-hmap-teamlive-settings', 'centralized-settings', 'attendance_settings', 'differential-pay-management']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("./tl-employer-settings.module.js");
                }
            },{
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/pay-runs/pay-runs.module.js");
                }
            },{
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/differential-pay-management/differential-pay-management.module.js");
                }
            },{
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/team-live/logbook/logbook.module.js");
                }
            }, {
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/holidays-and-absences/holidays-and-absences.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../../../modules/team_schedule/employer/benifits/employee-benefits.module.js')
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../../../hmodules/schedule-approval-flow/schedule-approval-flow.module.js');
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../../../hmodules/reporting-time/reporting-time.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../../../hmodules/job-titles-management/job-titles-management.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../../../hmodules/attendance-settings/attendance-settings.module.js')
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/activity-based-scheduling/activity-based-scheduling-settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/tl-compliance-settings/tl-compliance-settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import('../../../../hmodules/work-visas/work-visas.module.js');
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/work-restrictions/work-restrictions.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../../../hmodules/live-shift-alerts/live-shift-alerts.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../../../hmodules/notifications-management/notifications-management.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../../../hmodules/shared-hmap-teamlive-settings/shared-hmap-teamlive-settings.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("../../../../hmodules/jib-labor/jib-labor.module.js");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import('../../../../hmodules/live-shift-view/live-shift-view.module.js')
                }
            },
        ],
    }
};